const { FILLABLE_SVG_TAGS, SVG_ATTRIBUTES } = require('../constants');
const convertNamedColorToHex = require('../convertNamedColorToHex');
const getRGBAValues = require('../getRGBAValues');
const convertRgbaToHex = require('../convertRgbaToHex');
const isRgbFormat = require('../isRgbFormat');
const {
    DEFAULT_FILL,
    DEFAULT_OPACITY,
    DEFAULT_STROKE_WIDTH,
    FILL_NONE,
    TRANSPARENT_COLOR,
    HEX_REGEXP
} = require('./constants');

/**
 * Takes an array of layers and returns a color to layer ids map.
 * @param {Layer[]} layers
 * @param {{ withStrokes: boolean, ignoreTransparent: boolean }} flags
 * @returns {ColorsMap}
 */
const getColorsMap = (layers, { withStrokes = false, ignoreTransparent = false } = {}) => layers.reduce((colorMap, layer) => {
    if (!FILLABLE_SVG_TAGS.includes(layer.tag)) {
        return colorMap;
    }

    const appendColorEntryToMap = (color, entry) => {
        let normalizedColor = color;

        const isRgbColor = isRgbFormat(normalizedColor);

        if (isRgbColor) {
            normalizedColor = convertRgbaToHex(getRGBAValues(normalizedColor));
        }

        const isHexColor = HEX_REGEXP.exec(normalizedColor);

        normalizedColor = isHexColor ? normalizedColor : convertNamedColorToHex(normalizedColor);
        if (normalizedColor && entry) {
            const current = colorMap[normalizedColor] || [];
            Object.assign(colorMap, { [normalizedColor]: [...current, entry] });
        }
    };

    const { fill = DEFAULT_FILL, fillOpacity = DEFAULT_OPACITY } = { ...layer, ...layer.style };
    const colorEntry = getColorEntry(SVG_ATTRIBUTES.FILL, { fill, fillOpacity }, layer, { ignoreTransparent });
    appendColorEntryToMap(fill, colorEntry);

    if (withStrokes) {
        const { stroke, strokeWidth = DEFAULT_STROKE_WIDTH, strokeOpacity = DEFAULT_OPACITY } = { ...layer, ...layer.style };
        const colorEntry = getColorEntry(SVG_ATTRIBUTES.STROKE, { stroke, strokeOpacity, strokeWidth }, layer, { ignoreTransparent });
        appendColorEntryToMap(stroke, colorEntry);
    }

    return colorMap;
}, {});

const getColorEntry = (type, colorDescr, layer, { ignoreTransparent }) => {
    if (type === SVG_ATTRIBUTES.STROKE && parseFloat(colorDescr.strokeWidth) === 0) {
        return undefined;
    }

    const color = type === SVG_ATTRIBUTES.FILL ? colorDescr.fill : colorDescr.stroke;
    const colorOpacity = type === SVG_ATTRIBUTES.FILL ? colorDescr.fillOpacity : colorDescr.strokeOpacity;

    if (!color || color === FILL_NONE) {
        return undefined;
    }
    if (ignoreTransparent && (color === TRANSPARENT_COLOR || parseFloat(colorOpacity) === 0)) {
        return undefined;
    }

    const isGradient = color.startsWith('url');
    return Object.assign({
        isGradient,
        layerId: layer.layerId,
        tag: layer.tag,
        rootId: layer.rootId
    }, type === SVG_ATTRIBUTES.FILL
        ? { fill: color, fillOpacity: colorOpacity }
        : { stroke: color, strokeOpacity: colorOpacity }
    );
};

module.exports = getColorsMap;
